/**
 * Host projektu Supabase dla adresów publicznych bucketu `katalog-media`.
 * Jedyne miejsce, w którym warstwa oferty czyta środowisko — resztę trzymamy
 * czystą, żeby ten sam kod działał w testach i w podglądzie edytora.
 */
export const BAZA_PROJEKTU: string =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? '';
